/* ==========================================================================
   SelectRxjs > Client > Utils
   ========================================================================== */

/* Modules */
const configuration = require('../config');

/* Export */
module.exports = function Utils(instance) {
    return {
        /**
         * Fix selected choice
         */
        fixSelectedChoice: () => {
            if (!instance.choices) return;

            const choiceListEl = instance.choices.choiceList.element;

            choiceListEl.querySelectorAll('[data-choice]').forEach(el => {
                el.classList.remove(configuration().css.selected);

                const { value } = instance.choices.getValue() || {};
                const sValue = `${value}`;
                const dValue = el.dataset.value;

                if (sValue === dValue) {
                    el.classList.add(configuration().css.selected);
                }
            });
        }
    };
};
